import React, { useState, useEffect } from "react";
import _ from "lodash";
import "react-circular-progressbar/dist/styles.css";
import styles from "styles/settings.module.scss";
import classNames from "lib/classNames";
import Switch from "components/Switch";
import { formatMoney, watchChange, getCartValue, setSubtotal, watchCart } from "components/cart/Utils";

const Protection = ({ settings, isPreview, money_format,variants, currency, openTooltip }) => {
  const [checked, setChecked] = useState(false)
  const [calculatedPrice, setCalculatedPrice] = useState(0)
  const [cartValue, setCartValue] = useState(200 * 100)

  const {
    title,
    subtitle,
    selectedMessage,
    unselectedMessage,
    pricing,
    checker_type,
    checker_position,
    offer_position,
    pre_select,
    product_description,
    smartprotect,
    icon,
    priceStep,
    priceMin,

    tooltip= {
      active: false
    }
  } = settings;

  const formatColor = (color, alpha = null) =>
    !!color
      ? typeof color === "string"
        ? color
        : `rgba(${color?.r},${color?.g},${color?.b},${alpha || color?.a})`
      : undefined;

  useEffect(() => {

    const rate =  1 //Shopify?.currency?.rate ||
    let selectedPrice = priceMin
    let tmpCalc

    if (pricing.type === "percentage") {
      tmpCalc = (cartValue/rate * pricing.value) / 100 / 100
      tmpCalc = parseInt(tmpCalc)
    } else {
      tmpCalc = pricing.value / rate
    }

    if (isPreview) {
      selectedPrice = tmpCalc
    } else {
      if(pricing.type === "percentage"){
        if (tmpCalc >( priceMin + (priceStep * 98))) {
          selectedPrice = priceMin + (priceStep * 98)
        } else if(tmpCalc <= priceMin){
          selectedPrice = priceMin
        }else{
          
          let priceArray = Object.keys(variants).sort();
          
          let minDiff = 99999999
          priceArray.forEach((price) => {
            if(price !== "fixed"){
              let priceCalculation = Math.abs(parseFloat(price) - tmpCalc);
              if (priceCalculation < minDiff) {
                  selectedPrice = parseFloat(price);
                  minDiff = priceCalculation
              }
            }
          })
        }

        window.monster_protection_variant = variants[selectedPrice]
      }else {
        selectedPrice =  tmpCalc
        window.monster_protection_variant = variants.fixed
      }
        window.monster_protection_price = selectedPrice
    }
    setCalculatedPrice(selectedPrice * rate * 100)
  }, [cartValue, settings])

  useEffect(() => {
    const getCart = async () => {
      const value = await getCartValue()
      setCartValue(value)
    }
    if(!isPreview){
      getCart()
    }
  }, [])

  useEffect(() => {
    if(!isPreview){
      watchChange(() => {
        setTimeout(async () => {
          const value = await getCartValue()
          setCartValue(value)
        }, 1000)
      })
      
      watchCart(setCartValue)
    }
  }, [])

  useEffect(() => {
    if (checked) {
      setSubtotal(formatMoney(calculatedPrice + cartValue, money_format), currency)
    } else {
      setSubtotal(formatMoney(cartValue, money_format), currency)
    }
  }, [cartValue, calculatedPrice, checked])

useEffect(() => {
  if(pre_select){
    handleChange()
  }
},[])

  const handleChange = async () => {
    window.monster_protection_selected = !checked
    setChecked(!checked)
  }

  useEffect(() => {
    if( window.notifyMonsterUpsells){
      window.notifyMonsterUpsells({selected: checked, price: calculatedPrice})
    }
  }, [checked, calculatedPrice])


  const formatText = (text) => {
    if (!text) return ""
    return text
      .replace(/{{price}}/, formatMoney(calculatedPrice, money_format))
  }
  return (
    <div >
      <div className={styles.checkout}>
        {offer_position !== "above" && isPreview && (
          <div className={styles.btn}>Checkout - {formatMoney((checked ? (calculatedPrice + cartValue) : cartValue).toFixed(2), money_format)}</div>
        )}

        <div className={styles.offerContainer}>
          {
            checker_position === "left" && <div  className={styles.rightChecker}> <Checker {...{ checked, handleChange, checker_type }} /> </div>
          }
          <div className={styles.offer}>
            {
              icon?.image &&
              <div className={`${styles.previewIcon} ${!checked && styles.unchecked}`}>
                <img src={icon?.image} />
              </div>
            }
            <div className={styles.offerSide}>
              <div
                className={styles.titleContainer}
                style={{
                  fontSize: `${title.font_size}px`,
                  color: formatColor(title.color),
                }}
              >
                <div   className={styles.title}>
                  <div dangerouslySetInnerHTML={{
                      __html:formatText(`${title.text} {{price}}`),
                    }}/> 
                    {
                      tooltip.active ?
                        <div  
                          className={styles.tooltipContainer}
                          style={{color: "white",backgroundColor: formatColor(tooltip.symbol)}}  
                        >
                          <div>?</div>
                          <span 
                            className={`${styles.tooltiptext} ${openTooltip ? styles.open : ""}`}
                            style={{
                              color:  formatColor(product_description.color),
                              fontSize:  product_description.font_size + "px",
                              background:  formatColor(tooltip.background)
                            }}
                          >
                            {product_description.text} {`  `}
                            {tooltip.withLink &&
                              <span 
                                style={{
                                  color:  formatColor(tooltip.linkText.color),
                                  fontSize:  tooltip.linkText.font_size + "px",
                                  textDecoration: "underline"
                                }}
                                onClick={() => window.open(tooltip.link,"_blank")}
                              >
                                {tooltip.linkText.text}
                            </span>
                            }
                            
                          </span>
                        </div>
                        : undefined
                    }
                  </div>
                  {
                    checker_position === "right" && <Checker {...{ checked, handleChange, checker_type }} />
                  }
              </div>
              {
                selectedMessage ?
                    !checked ? 
                      <div
                        className={styles.subtitle}
                        style={{
                          fontSize: `${selectedMessage.font_size}px`,
                          color: formatColor(selectedMessage.color),
                        }}
                      >
                      <div dangerouslySetInnerHTML={{
                          __html:formatText(selectedMessage.text),
                        }}/> 
                    </div>
                    :
                    <div
                      className={styles.subtitle}
                      style={{
                        fontSize: `${unselectedMessage.font_size}px`,
                        color: formatColor(unselectedMessage.color),
                      }}
                    >
                    <div dangerouslySetInnerHTML={{
                        __html:formatText(unselectedMessage.text),
                      }}/> 
                  </div>
                :
                 ( <div
                    className={styles.subtitle}
                    style={{
                      fontSize: `${subtitle.font_size}px`,
                      color: formatColor(subtitle.color),
                    }}
                  >
                    <div dangerouslySetInnerHTML={{
                      __html:formatText(subtitle.text),
                    }}/> 
                  </div>)
              }
              {smartprotect && (
                <div
                  className={styles.subtitle}
                  style={{
                    fontSize: `12px`,
                    color: formatColor(subtitle.color),
                  }}
                >
                  Powered by{" "}
                  <span className={classNames("underline")}>ShipProtect</span>
                </div>
              )}
            </div>
          </div>
        </div>
        {offer_position === "above" && isPreview && (
          <div className={styles.btn}>Checkout - {formatMoney((checked ? (calculatedPrice + cartValue) : cartValue).toFixed(2), money_format)}</div>
        )}
      </div>
    </div>
  );
};

const Checker = ({ checked, handleChange, checker_type }) => {
  
  return (
    checker_type === "ticker" ?
      <div
        className={ styles.monsterCheckbox}
        style={{
          color: "white",
          border: "2px solid black",
          width: "18px",
          height: "18px",
          padding: "2px",
          background: checked ? "black" : "white",
          outline: "none!important"
        }}
        onClick={handleChange}
      >
        <svg
          aria-hidden="true"
          focusable="false"
          data-icon="check"
          style={{ width: 10, height: 10 }}
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          className={classNames({ 'opacity-0': !checked })}
        >
          <path
            fill="currentColor"
            d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
          ></path>
       </svg>
      </div>
      :
      <Switch noText={true} value={checked} onChange={handleChange} offColor="#808080" />
  )
};

export default Protection;
